module.exports = __webpack_public_path__ + "img/WebIllustration.3e6d244c.png";